module.exports = __webpack_public_path__ + "img/Stemness-BRCA_SpatialResearch.e1756420.png";